module.exports = __webpack_public_path__ + "img/icon-table-view.93579f24.svg";